<template>
  <div class="kj-pro">
    <div class="kj-pro-domain" v-if="!isDomainGood">砍价活动正在疯狂准备中，请联系客服！<a href="/">点击进入主页</a></div>
    <div class="kj-pro-mobi" v-if="!isMobile">
      <div class="kj-pro-mobi_cont">
        <span>微信扫一扫参与砍价任务!</span>
        <img :src="qrcode" v-if="qrcode">
      </div>
    </div>
    <div class="kj-pro-done" v-if="congratulation">
      <Congratulation :congratulationInf="congratulationInf"
                      :qrcode="qrcode"
                      :shortUrl="shortUrl"
                      :campaignInf="campaignInf"
                      :currentPlay="currentPlay"
                      :bargainInf="bargainInf"
                      :stock = "bargainInf.inventory"
                      :hasOrder = "hasOrder"
                      :item="item">
      </Congratulation>
    </div>
    <div class="kj-pro-cont" v-else>
      <div class="kj-pro-info">
        <div class="kj-pro-info_title">↓<span>砍价优惠中</span>↓</div>
        <button class="kj-pro-info_order" v-if="hasOrder" @click="handleBargainOrderClick">砍价订单</button>
        <img class="kj-pro-info_img" :src="campaignInf.product_image_url" v-if="campaignInf.product_image_url" />
        <div class="kj-pro-info_name">{{bargainInf.title}}</div>
        <div class="kj-pro-items">
          <div class="kj-pro-item">
            <div class="kj-pro-info_pro_sum">仅剩 <Number :inventory="bargainInf.inventory"></Number> 件</div>
            <div class="kj-pro-info_time"><CountDown :time="time"></CountDown></div>
          </div>
          <button class="kj-pro-info_go jsScrollTop" @click="handleCommodityInf">查看商品详情</button>
        </div>
        <div class="kj-pro-progress">
          <div class="kj-pro-progress_prices">
            <div class="kj-pro-progress_price_min" v-if="can_show_lowest_price">底价<span>￥{{(bargainInf.lowest_price/100).toFixed(2)}}</span></div>
            <div class="kj-pro-progress_price_max">原价￥{{(bargainInf.original_price/100).toFixed(2)}}</div>
          </div>
          <ProgressBar class="kj-pro-progress_bar" :progress="progress"></ProgressBar>
          <div class="kj-pro-progress_now_price">
            <CurrentPrice :currentPrice="(bargainInf.amount_after ? bargainInf.amount_after : bargainInf.original_price)"
                          :currentPriceAvatar="this.currentPriceAvatar">
            </CurrentPrice>
          </div>
        </div>
      </div>
      <div class="kj-pro-activity_cont">
        <ActivityContent :player="player" :id="player.playId" :terms="terms"></ActivityContent>
      </div>
      <div class="kj-pro-recommend">
        <div class="kj-pro-recommend_title">商品详情</div>
        <div class="kj-pro-recommend_info" v-html="bargainInf.product_html"></div>
      </div>
      <div class="kj-pro-btns">
        <BargainButton
          :item="item"
          :selectIndex="index"
          :currentPlay="currentPlay"
          :campaignInf="campaignInf"
          :title="bargainInf.title"
          :imgSrc = "imgSrc"
          :lowestPrice = "(bargainInf.lowest_price/100).toFixed(2)"
          :originPrice = "(bargainInf.original_price/100).toFixed(2)"
          :shortUrl = "short_url"
          :qrcode = "qrcode"
          :hasOrder = "hasOrder"
          :stock = "bargainInf.inventory"
          @bargainForMysel = "handleBargainForMysel">
        </BargainButton>
      </div>
    </div>
  </div>
</template>
<script>
  import ProgressBar from 'base/progressBar'
  import CountDown from 'base/countDown'
  import Number from 'base/number'
  import BargainButton from 'base/bargainButton'
  import ActivityContent from 'base/content'
  import ParticipatorList from 'base/participatorList'
  import Congratulation from 'components/bargainResult'
  import CurrentPrice from './subpage/currentPrice.vue'
  import {goHasPlayIdParamURl} from 'common/util/goHasPlayIdParamURl'

  import {Chain} from 'common/js/bargainChain'
  import {getActivityInfById} from 'api/getActivityInfById'
  import {sendStatToApi} from 'api/sendStatToApi'
  import {getCommodityStock} from 'api/getCommodityStock'
  import {getCommodityInf} from 'api/getCommodityInf'
  import {getFriendsActivityInfById} from 'api/getFriendsActivityInfById'
  import {postWxToken} from 'api/postWxToken'
  import {getQrcode} from 'api/getQrcode'
  import {transformShortUrl} from 'api/transformShortUrl'
  import {getPlayer} from 'common/util/getPlayer'
  import {isPcOrMobile} from 'common/util/isPcOrMobile'
  import {isActivityOntime} from 'common/util/isActivityOntime'
  import {isActivityBegin} from 'common/util/isActivityBegin'
  import {formatDate} from 'common/util/formatDate'
  import {localstorageSetItem} from 'common/util/localstorageUtil'
  import {isDomainGood} from 'common/util/isDomainGood'
  import {getWxToken} from 'common/util/getWxToken'
  import {getNewWxConfigParam, reconfigWx} from 'common/util/wxUrlConfig'
  import {getUvKeyFromCookie} from 'common/util/getUvKeyFromCookie'

  export default {
    data () {
      return {
        isMobile: true,
        isDomainGood: true,
        contentShow: false,
        congratulation: false,
        congratulationInf: undefined,
        bargainInf: {
          title: '',
          number: '',
          start_time: '',
          end_time: '',
          original_price: '',
          lowest_price: '',
          inventory: '',
          amount_after: '',
          bargain_amount: '',
          product_html: ''
        },
        participatorList: '',
        isBargainForYourself: false,
        isBargainedForYourself: false,
        isBargainedForHimself: false,
        player: {},
        isShowCommodityInf: false,
        imgSrc: '',
        currentPriceAvatar: '',
        short_url: '',
        qrcode: '',
        terms: '',
        can_show_lowest_price: 0,
        //重构
        campaignInf: {
          can_show_lowest_price: '',
          created_at: '',
          deleted_at: '',
          end_time: '',
          handle: '',
          highest_price_to_order: '',
          id: '',
          inventory: '',
          lowest_price: '',
          mode: '',
          name: '',
          need_subscribe_to_help: '',
          need_subscribe_to_play: '',
          original_price: '',
          product_html: '',
          product_id: '',
          product_image_url: '',
          product_name: '',
          purchase_mode: '',
          same_person_rule: '',
          share_desc: '',
          share_image_url: '',
          share_title: '',
          shop_key: '',
          short_url: '',
          start_time: '',
          terms: '',
          updated_at: '',
          wechat_description: "useless",
          wechat_img_url: "useless",
          wechat_keyword: "useless",
          wechat_title: "useless"
        },
        myPlay: null,
        currentPlay: null,
        friendPlay: null,
        item: {
          product_id: null,
          variant_id: null,
          quantity: 1
        }
      }
    },
    computed: {
      time: function () {
        let end = new Date(this.bargainInf.end_time)
        let start = new Date(Date.now())
        let ms = end.getTime() - start.getTime()
        let seconds = ms / 1000 > 0 ?  ms / 1000 : 0
        return Math.ceil(seconds)
      },
      progress: function () {
        let now = this.bargainInf.amount_after
        let old = this.bargainInf.original_price
        if (!now) {
          let progress = 1
          return progress.toFixed(1)
        }
        let progress = now / old
        return progress.toFixed(1)
      },
      index : function () {
        if (!this.currentPlay) {
          return 1
        }
        if (this.myPlay && this.myPlay.id === this.currentPlay.id) {
          return 2
        }
        if (this.currentPlay && !this.currentPlay.help_record_count && (!this.myPlay || this.currentPlay.id !== this.myPlay.id) ) {
          return 3
        }
        if (this.currentPlay && !!this.currentPlay.help_record_count && (!this.myPlay || this.currentPlay.id !== this.myPlay.id) ) {
          return 4
        }
      },
      hasOrder: function () {
        if (this.myPlay && (this.myPlay.id === this.currentPlay.id) && this.currentPlay.has_order) {
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      handleCommodityInf () {
        this.isShowCommodityInf = true
      },
      handleBargainForMysel (congratulationInf) {
        this.congratulationInf = congratulationInf
        this.congratulation = true
      },
      handleBargainOrderClick () {
        const orderNo = this.currentPlay.order_no
        window.location.href = `/account/orders/${orderNo}`
      },
      initCommodityDetailsClick () {
        let goTitle = document.querySelector('.kj-pro-info_go')
        let title = document.querySelector('.kj-pro-recommend_title')
        goTitle.addEventListener('click', function () {
          document.body.scrollTop = title.offsetTop
        })
      },
      async postWxTokenFromUrl (token) {
        postWxToken(token).catch((err) => {})
      },
      async generateFirstQrcode () {
        this.qrcode = await getQrcode(window.location.href)
      },
      async sendStat(campaignId) {
        let uvKey = getUvKeyFromCookie()
        if (uvKey) {
          await sendStatToApi(uvKey, campaignId)
        }
      },
      //  为sku配置item id
      async getItem () {
        let handleId = ''
        let regx = ''
        if (window.location.href.indexOf('?') !== -1) {
          regx = /\/products\/.+|\/products\/.+?/
          handleId = window.location.href.match(regx).join('').split('/')[2].split('?')[0]
        } else {
          regx = /\/products\/.+|\/products\/.+?/
          handleId = window.location.href.match(regx).join('').split('/')[2].split('#')[0]
        }
        let commodity = await getCommodityInf(handleId)
        if (!commodity) {
          return
        }
        this.item.product_id = commodity.id - 0
        this.item.variant_id = commodity.variants[0].id - 0
      }
    },
    async created () {
      this.getItem()
      // 查看Wxtoken，有就提交
      const wxToken = getWxToken()
      if (wxToken) {
        this.postWxTokenFromUrl(wxToken)
      }
      //  判断商家是否配置独立域名
      this.isDomainGood = isDomainGood()
      //  判断用户是否是手机登录
      if (isPcOrMobile() !== 'phone') {
        this.isMobile = false
      }
      localStorage.clear()
      const player = await getPlayer()
      this.sendStat(player.campaignId)
      this.player = player
      try {
        let activityInf = await getActivityInfById(player.campaignId)
        // 库存以sass为主
        let inventoryFromSass = await getCommodityStock(activityInf.campaign.handle)
        this.campaignInf = activityInf.campaign
        this.campaignInf.inventory = inventoryFromSass
        document.title = this.campaignInf.name
        if (activityInf.play) {
          this.myPlay = activityInf.play
          this.currentPlay = activityInf.play
          if (activityInf.play.id === player.playId) {
            player.isBargainForYourself = true
          }
        }
        if (player.playId) {
          if (!this.myPlay || (this.myPlay.id !== player.playId)) {
            this.friendPlay = await getFriendsActivityInfById(player.playId)
            if (this.friendPlay) {
              this.currentPlay = this.friendPlay
            }
          }
        }
        this.bargainInf.title = this.campaignInf.product_name
        this.bargainInf.number = this.campaignInf.inventory
        this.bargainInf.start_time = this.campaignInf.start_time
        this.bargainInf.end_time = this.campaignInf.end_time
        this.bargainInf.original_price = this.campaignInf.original_price
        this.bargainInf.lowest_price = this.campaignInf.lowest_price
        this.bargainInf.inventory = this.campaignInf.inventory
        this.bargainInf.product_html = this.campaignInf.product_html
        this.imgSrc = this.campaignInf.share_image_url
        this.short_url = this.campaignInf.short_url
        this.terms = this.campaignInf.terms
        this.can_show_lowest_price = this.campaignInf.can_show_lowest_price
        //Wx分享配置
        let shareUrl = window.location.href.replace(window.location.hash, '')
        const wxConfig = getNewWxConfigParam(this.campaignInf, this.currentPlay)
        let bargainLoginTimes = localStorage.getItem('bargainLoginTimes')
        //  处理url，避免分享出带权限的链接， 前端可以拿到带权限的url，权限策略有漏洞
        if (wxConfig.link && wxConfig.link.indexOf('/account/social/login') !== -1 && !bargainLoginTimes) {
          localStorage.setItem('bargainLoginTimes', 1)
          window.location.reload()
        } else  if (wxConfig.link && wxConfig.link.indexOf('/account/social/login') !== -1 && bargainLoginTimes === 1) {
          localStorage.removeItem('bargainLoginTimes')
        } else {
          reconfigWx(wxConfig)
        }
        //  如果不存在currentPlay, 则用户自己参与砍价（当前未参与）
        this.generateFirstQrcode()
        if (this.currentPlay) {
          this.bargainInf.bargain_amount = this.currentPlay.bargain_amount
          this.bargainInf.amount_after = this.currentPlay.amount_after
          this.player.playId = this.currentPlay.id
          localstorageSetItem('playerId', this.currentPlay.id)
          localstorageSetItem('campaignId', this.currentPlay.campaign_id)
          // goHasPlayIdParamURl(this.currentPlay.id)
          const url = `/products/${this.campaignInf.handle}?yhsd-play-mode=kanjia&kj-campaign-id=${this.campaignInf.id}&kj-play-id=${this.currentPlay.id}`
          window.history.pushState(null, null, url)
          //Wx分享配置
          let shareUrl = window.location.href.replace(window.location.hash, '')
          const wxConfig = getNewWxConfigParam(this.campaignInf, this.currentPlay)
          reconfigWx(wxConfig)
          this.qrcode = await getQrcode(window.location.href)
          transformShortUrl(window.location.href).then((res) => {
            this.short_url = res.data.data
          })
          this.currentPriceAvatar = this.currentPlay.avatar
        }
        //  判断活动是否开始
        if (!isActivityBegin(this.campaignInf.start_time)) {
          this.$dialog.confirm({
            title: ' ',
            mes: `该活动将于${formatDate(new Date(this.campaignInf.start_time), 'yyyy-MM-dd hh:mm')}正式开始`,
            opts: [
              {
                txt: '随便逛逛',
                color: true,
                callback: () => {
                const url = window.location.host + window.location.pathname
                window.location.href = '//' + url
                }
              }
            ]
          })
        }
        //  判断活动是否过期
        if (!isActivityOntime(this.campaignInf.end_time)) {
          this.$dialog.confirm({
            title: ' ',
            mes: '砍价任务仍在筹备中，随便逛逛吧!',
            opts: [
              {
                txt: '随便逛逛',
                color: true,
                callback: () => {
                const url = window.location.host + window.location.pathname
                window.location.href = '//' + url
                }
              }
            ]
          })
        }
        //  库存不足或商品已下架
        if (this.bargainInf.inventory === 0) {
          this.$dialog.confirm({
            title: ' ',
            mes: '库存为0，该商品已被抢光！',
            opts: [
              {
                txt: '随便逛逛',
                color: true,
                callback: () => {
                const url = window.location.host + window.location.pathname
                window.location.href = '//' + url
                }
              }
            ]
          })
        }
      } catch(err) {
        if (err.message) {
          this.$dialog.alert({mes: `${err.message}`})
          return
        }
        this.$dialog.alert({
          mes: `${err}`,
          opts: () => {
            const url = window.location.host + window.location.pathname
            window.location.href = '//' + url
          }
        })
      }
      window.$('.kj-layer.mask-black-dialog').remove()
    },
    mounted () {
      this.initCommodityDetailsClick()
    },
    components: {
      ProgressBar,
      CountDown,
      Number,
      CurrentPrice,
      ParticipatorList,
      BargainButton,
      ActivityContent,
      Congratulation
    }
  }
</script>
<style scoped>
.kj-pro-cont {
  margin: 0 auto;
  padding: 0 0 110px;
  max-width: 768px;
}

.kj-pro-domain {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  right: 0;
  padding: 30% 10%;
  background-color: #fff;
  z-index: 2;
  font-size: 0.4rem;
  line-height: 150%;
  color: #333;
}

.kj-pro-domain a {
  color: #26a4ff;
}

.kj-pro-mobi {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1;
  font-size: 0;
  line-height: 0;
}

.kj-pro-mobi_cont {
  display: inline-block;
  text-align: center;
  width: 250px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -70%);
  will-change: transform;
}

.kj-pro-mobi_cont span {
  display: block;
  margin: 0 0 26px;
  color: #fff;
  font-size: 16px;
}

.kj-pro-mobi_cont img {
  display: block;
  margin: 0 auto;
  width: 180px;
  height: 180px;
}

.kj-pro-info {
  position: relative;
  background: linear-gradient(#179dff, #5741ff);
  margin: 0 auto;
  padding: 0 15px;
  overflow: hidden;
  color: #fff;
}
.kj-pro-info_order {
  display: block;
  position: absolute;
  top: 14px;
  right: 11px;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  font-size: 14px;
  line-height: 1;
}
.kj-pro-info_title {
  position: relative;
  margin: 0 auto;
  padding: 10px 0;
  width: 150px;
  text-align: center;
  border-radius: 0 0 8px 8px;
  font-size: 16px;
  line-height: 1;
  background-color: #ff4444;
}
.kj-pro-info_title span {
  margin: 0 8px;
}
.kj-pro-info_img {
  display: block;
  margin: 24px auto 22px;
  width: 234px;
  height: 234px;
  border-radius: 10px;
  box-shadow: 0 12px 20px 0 #4f4cff;
  object-fit: cover;
}
.kj-pro-info_name {
  font-size: 18px;
  line-height: 28px;
}
.kj-pro-items {
  display: flex;
  margin: 15px 0 18px;
}
.kj-pro-item {
  margin: auto;
  flex: 1;
}
.kj-pro-info_pro_sum {
  margin: 0 0 3px;
  font-size: 14px;
  line-height: 1;
}
.kj-pro-info_time {
  color: #fff;
  opacity: .65;
  font-size: 14px;
}
.kj-pro-info_go {
  outline: none;
  display: inline-block;
  margin: auto;
  font-size: 14px;
  padding: 7px 8px;
  border: .5px solid #fff;
  border-radius: 5px;
  background-color: transparent;
  line-height: 1;
  height: fit-content;
}
.kj-pro-progress_bar {
  margin: 10px 0 13px;
}
.kj-pro-progress_now_price {
  display: flex;
  margin: 0 0 22px;
}
.kj-pro-progress_prices {
  display: flex;
  font-size: 14px;
  line-height: 1;
}
.kj-pro-progress_price_min {
  flex: 1;
  margin: auto;
  color: #fff444;
}
.kj-pro-progress_price_min span {
  font-size: 21px;
  font-weight: bold;
}
.kj-pro-progress_price_max {
  flex: 1;
  margin: auto;
  text-align: right;
  opacity: .65;
}

.kj-pro-btns {
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: #fff;
  box-shadow: 0 0 5px 0 #bbbbbb;
}

.kj-pro-activity_cont {
  margin: 28px 15px 0;
}

.kj-pro-recommend {
  margin: 30px auto 0;
  padding: 0 15px;
  overflow: hidden;
}
.kj-pro-recommend_title {
  margin: 0 0 15px;
  font-size: 24px;
  line-height: 1;
}

.kj-pro-done {
  position: fixed;
  background: #fff;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>





// WEBPACK FOOTER //
// index.vue?046bb7db